import { Component, OnInit,Inject, Input, Output, EventEmitter } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Analise, Projeto } from 'src/app/dashboard/models/analise';
import { AppUserService } from 'src/app/dashboard/services/app-user.service';
import { MapConfig } from 'src/app/instant-analysis/models/map-config';
import { MathAux } from 'src/app/instant-analysis/services/math-aux/math-aux';
import { MapConfigService } from 'src/app/shared/services/map-config/map-config.service';
import { LocalStorageService } from 'src/app/shared/util/local-storage';
import { AnalysisSavingMode } from '../models/analysis-saving-mode';
import { SaveAnalysisResponse } from '../models/save-analysis-response';

/**
 * Diálogo de salvamento de análise.
 */
@Component({
  selector: 'app-save-analysis-dialog',
  templateUrl: './save-analysis-dialog.component.html',
  styleUrls: ['./save-analysis-dialog.component.css'],
})
export class SaveAnalysisDialogComponent implements OnInit {

  /** Opção selecionada para o modo de gravação */
  selected: AnalysisSavingMode = AnalysisSavingMode.SAVE_IN_NEW_ANALYSIS;

  /** Observable da busca de projetos do usuário. */
  projeto$: Observable<Projeto[]>;

  /** Array de projetos do usuário */
  projetos: Projeto[] = [];

  selectedProject: Projeto;

  /** Deep copy da análise atualmente selecionada pelo usuário */
  // auxAnalysis:Analise = MathAux.deepCopy(this.data.currentAnalysis);

  analysisName: string = "";

  /** Campo para o usuário fornecer o nome de um projeto novo. */
  newProjectName = "";

  AnalysisSavingMode = AnalysisSavingMode;

  @Input() mapConfig: MapConfig;

  @Output() saved: EventEmitter<SaveAnalysisResponse> = new EventEmitter<SaveAnalysisResponse>();

  @Output() error: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    // public dialogRef: MatDialogRef<SaveAnalysisDialogComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: {currentAnalysis:Analise,originalAnalysis:Analise}, 
    private mapConfigService: MapConfigService,
    private appUserService: AppUserService,
    private localStorageService: LocalStorageService) {}

  ngOnInit(): void {
    // console.log(this.data.currentAnalysis)
    let userId = this.localStorageService.getUserId();
    this.projeto$ = this.appUserService.getAllProjectsFromUser(userId);
    this.projeto$.subscribe(val=>{
      this.projetos=val
      // O usuário está em uma análise que já foi salva antes
      if(this.mapConfig.details.analysisId) {
        this.selected = AnalysisSavingMode.SAVE_IN_CURRENT_ANALYSIS;
      }
      // O usuário não criou nenhum projeto ainda
      else if(this.projetos.length < 1) {
        this.selected = AnalysisSavingMode.SAVE_IN_NEW_PROJECT;
      }
      // O usuário tem projeto, mas não tem análise salva ainda
      else {
        this.selected = AnalysisSavingMode.SAVE_IN_NEW_ANALYSIS;
      }
    });
  }

  /**
   * Trata o click no botão de conclusão do formulário de gravação da análise.
   */
  onNoClick(): void {

    let analysis: Analise = this.mapConfigService.createAnalysis(this.mapConfig);

    switch(this.selected){
      case AnalysisSavingMode.SAVE_IN_CURRENT_ANALYSIS:
        this.appUserService.editAnalysis(analysis).subscribe(response=>{
          this.saved.emit(response);
        },
        err => {
          this.error.emit(err);
        })
        break;
      case AnalysisSavingMode.SAVE_IN_NEW_ANALYSIS:

        analysis['id_projeto'] = this.selectedProject.id;
        this.appUserService.addAnalysisToProject(analysis).subscribe(response => {
          let { analysisId } = response.data;
          this.mapConfig.details.analysisId = analysisId;
          this.saved.emit(response);
        },
        err => {
          this.error.emit(err);
        });

        break;
      case AnalysisSavingMode.SAVE_IN_NEW_PROJECT:

        let userId = this.localStorageService.getUserId();
        
        const newProject: Projeto = {
          id: null,
          nome: this.newProjectName,
          id_app_user: userId,
          analises: [
            analysis
          ],
        };

        this.appUserService.addProject(newProject).subscribe(
          response => {
            let { projectId, analysisId } = response.data;
            this.mapConfig.details.projectId = projectId;
            this.mapConfig.details.analysisId = analysisId;
            this.saved.emit(response);
          },
          err => {
            this.error.emit(err);
          }
        );

    }
  }



}
